/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  (function () {
    const addToCartButton = document.querySelector('.product__submit__add');
    let lastSelectedPrice = null;

    function getRechargeWidgetShadowRoot() {
        const rechargeWidget = document.querySelector('recharge-subscription-widget');
        return rechargeWidget ? rechargeWidget.shadowRoot : null;
    }

    function updateButtonWithPrice(selectedPrice, salePrice) {
		console.log("updateButtonWithPrice: " + selectedPrice);

        if (selectedPrice && addToCartButton) {
            const buttonTextSpan = addToCartButton.querySelector('i');
            
            if (buttonTextSpan) {
                buttonTextSpan.innerHTML = ` • ${selectedPrice}`;
                
                if (selectedPrice < salePrice) {
                	buttonTextSpan.innerHTML +=  ' <s>' + `${salePrice}` + '</s>';
                }
            }
        }
    }

    function getSelectedPrice() {
        const shadowRoot = getRechargeWidgetShadowRoot();

        let selectedPrice = null;

        if (shadowRoot) {
            const subscriptionOption = shadowRoot.querySelector('.rc-purchase-option__subscription');
            const oneTimeOption = shadowRoot.querySelector('.rc-selection__onetime');

            if (subscriptionOption && subscriptionOption.hasAttribute('rc-selected')) {
                const discountedPriceElement = subscriptionOption.querySelector('.rc-price:not(.strike-through)');
                selectedPrice = discountedPriceElement ? discountedPriceElement.innerText.replace(/[^0-9.$]/g, '').trim() : null;
            } else if (oneTimeOption && oneTimeOption.hasAttribute('rc-selected')) {
                const oneTimePriceElement = oneTimeOption.querySelector('.rc-price');
                selectedPrice = oneTimePriceElement ? oneTimePriceElement.innerText.replace(/[^0-9.$]/g, '').trim() : null;
            }
        }

        // Fallback to default price if no valid selected price found
        if (!selectedPrice) {
			console.log("Fallback to default price, no valid selected price found");
            const fallbackPriceElement = document.querySelector('.product__price span');
            selectedPrice = fallbackPriceElement ? fallbackPriceElement.innerText.trim() : null;
        }

        return selectedPrice;
    }

    function getSelectedOriginalPrice() {
		const fallbackPriceOriginalElement = document.querySelector('.product__price--strike');
		
		let selectedOriginalPrice = fallbackPriceOriginalElement ? fallbackPriceOriginalElement.innerText.trim() : null;

        return selectedOriginalPrice;
    }

    function startPricePolling() {
        setInterval(() => {
            const currentSelectedPrice = getSelectedPrice();
            const currentSelectedOriginalPrice = getSelectedOriginalPrice();
            
            if (currentSelectedPrice !== lastSelectedPrice && currentSelectedPrice) {
                updateButtonWithPrice(currentSelectedPrice, currentSelectedOriginalPrice);
                lastSelectedPrice = currentSelectedPrice;
            }
        }, 500);
    }

    startPricePolling();
  })();


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
